import Vue from 'vue';
import Vuex from 'vuex';
import sharedMutations from "vuex-shared-mutations";

import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexSession = new VuexPersistence({
	key: 'cwp',
	storage: window.localStorage,
	reducer: state => ({
		sessionExpiresAt:		state.sessionExpiresAt,
	})
});

export default new Vuex.Store({
	plugins:		[
		vuexSession.plugin,
		sharedMutations({ predicate: ["setSessionExpiresAt", "openSessionExpiresWarningModal", "closeSessionExpiresWarningModal"] })
	],
	state:			{
		sessionExpiresAt:			'',
		showSessionExpiresWarningModal: false,
	},
	actions: {

	},
	mutations:	{
		setSessionExpiresAt(state, payload) {
			state.sessionExpiresAt = payload;
		},
		openSessionExpiresWarningModal(state, payload) {
			state.showSessionExpiresWarningModal = true;
		},
		closeSessionExpiresWarningModal(state, payload) {
			state.showSessionExpiresWarningModal = false;
		},
	},
	getters:	{
		sessionExpiresAt: state => state.sessionExpiresAt,
		showSessionExpiresWarningModal: state => state.showSessionExpiresWarningModal,
	}
});
